export enum UserType {
  ADMIN = "管理者",
  NORMAL = "一般ユーザー",
}
